import { mockResponse, request, isMockMode } from './client.js';
import { DART_CARDS, DART_CARD_ACTIVATION_STEPS } from '../data/dart-cards.js';

/**
 * 取得飛鏢機卡清單。
 *
 * @param brand  選填，CARD_BRANDS 列舉（'DARTSLIVE'|'PHOENICA'）；不傳則回全部
 */
export function getDartCards({ brand } = {}) {
  if (!isMockMode()) {
    const qs = brand ? `?brand=${brand}` : '';
    return request(`/dart-cards${qs}`);
  }
  return mockResponse(() => {
    if (!brand) return DART_CARDS;
    return DART_CARDS.filter(c => c.brand === brand);
  });
}

export function getDartCardActivationSteps() {
  if (!isMockMode()) return request('/dart-cards/activation-steps');
  return mockResponse(DART_CARD_ACTIVATION_STEPS);
}
